// interface Model {
//   id: number;
//   name: string;
//   code: string;
//   created_at: string;
//   updated_at: string;
//   visible_cars?: Array<Car>;
//   type: Type;
//   type_id: number;
//   url: string | null;
// }

// interface Car {
//   model_id: number;
//   id: number;
//   name: string;
//   code: string;
//   web_description: string | null;
// }

// interface Trim {
//   id: 58;
//   name: 'Ceed SW PHEV Advance Plus';
//   code: 'JMW5K6A1TEV2HH01U';
//   model_id: 3;
//   created_at: '2023-03-30T11:51:39.000000Z';
//   updated_at: '2023-04-26T11:13:33.000000Z';
//   active: 1;
//   image: string | null;
//   features: null;
//   reach: null | string;
//   emission_disclaimer: string | null;
//   emissions: string | null;
//   electric_consumption: string | null;
//   price: number;
//   type_id: null;
//   model: {
//     id: 3;
//     name: 'Ceed';
//   };
//   type: null;
//   categories: [];
//   private_leasing: PrivatLeasing[];
//   corporate_leasing: BusinessLease[];
//   loan: Loan[];
//   web_description: string | null;
//   financial_leasing: FinancialLease[];
// }

// interface PrivatLeasing {
//   id: 3;
//   supplement: null;
//   cash_investment: 10;
//   incl_first_increased_rent: 3797;
//   car_id: 58;
//   created_at: '2023-05-22T12:51:25.000000Z';
//   updated_at: '2023-05-22T12:51:25.000000Z';
//   incl_service_agreement: number;
// }

// interface Loan {
//   id: 13;
//   incl_service_agreement: number;
//   cash_investment: 20;
//   disclaimer: null | string;
//   car_id: 58;
//   created_at: '2023-04-26T11:13:33.000000Z';
//   updated_at: '2023-05-10T11:10:26.000000Z';
// }

// interface BusinessLease {
//   id: 30;
//   incl_service_agreement: string | null;
//   cash_investment: string | null;
//   lease: string | null;
//   beneficial_value: number | null;
//   car_id: number;
//   created_at: '2023-06-01T10:36:30.000000Z';
//   updated_at: '2023-06-01T10:36:30.000000Z';
//   rent_4500: number;
//   rent_6000: number;
//   rent_9000: number;
//   rent_12000: number;
// }

// interface Type {
//   name: string;
//   id: number;
// }

// interface FinancialLease {
//   id: 45;
//   car_id: 45;
//   rent_4500: 4894;
//   rent_6000: 5647;
//   rent_9000: 6350;
//   rent_12000: 7086;
//   created_at: '2023-04-26T11:12:05.000000Z';
//   updated_at: '2023-04-26T11:12:05.000000Z';
// }

type Type = App.Models.Type;
type FinancialLease = App.Models.FinancialLeasing;
type BusinessLease = App.Models.BusinessLeasing;
type Loan = App.Models.Loan;
type PrivatLeasing = App.Models.PrivateLeasing;
type Model = App.Models.CarModel;
type Trim = App.Models.Car;

type Car = Pick<App.Models.Car, 'model_id' | 'name' | 'code' | 'id' | 'web_description'>;
interface ModelWithTrim extends Model {
  first_car: Trim;
}

enum FinanceOption {
  All = 'Alla',
  PrivatLeasing = 'Privatleasing',
  Loan = 'Billån',
  BusinessLease = 'Business Lease',
}
enum BusinessDistance {
  One = '1500',
  Two = '2000',
  Three = '3000',
  Four = '4000',
}
enum PrivateDistance {
  One = '1000',
}
enum LoanDistance {
  One = '1500',
}

export type { Model, Car, Trim, Loan, PrivatLeasing, BusinessLease, Type, FinancialLease, ModelWithTrim };
export { FinanceOption, BusinessDistance, PrivateDistance, LoanDistance };
